module.exports = __webpack_public_path__ + "img/15.42247500.png";